import { faFilePdf } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useRef, useState } from "react";

const FileUploader = ({
  handleFileChange,
  highlightFileUploader,
}) => {
  const fileInputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);

  const openFileExplorer = () => {
    fileInputRef.current.click();
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const files = e.dataTransfer.files;
    if (files.length) {
      const event = { target: { files: files } };
      handleFileChange(event);
    }
  };

  return (
    <div
      className={`mt-1 flex justify-center px-6 py-4 my-2 border-2 border-dashed rounded-xl cursor-pointer transition-all mb-4 ${
        isDragging
          ? "border-indigo-400 bg-indigo-50 dark:border-indigo-400 dark:bg-indigo-900/70 cursor-copy"
          : highlightFileUploader
          ? "border-indigo-500 bg-indigo-100 dark:border-indigo-300 dark:bg-indigo-900/50"
          : "border-gray-300 dark:border-gray-700 dark:hover:border-indigo-300 hover:border-indigo-300"
      }`}
      onClick={openFileExplorer}
      onDragEnter={handleDragEnter}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <div className="space-y-1 text-center">
        <FontAwesomeIcon icon={faFilePdf} size="2x" />
        <div className="flex flex-row items-center text-sm text-gray-600">
          <span className="font-medium text-indigo-600">
            {isDragging ? "Drop" : "Upload"}
          </span>
          <p className="pl-1 text-sm">your template</p>
        </div>
        <p className="text-xs text-gray-500">10MB limit, PDFs only</p>
      </div>
      <input
        ref={fileInputRef}
        id="file-upload"
        name="template"
        type="file"
        accept="application/pdf"
        className="sr-only"
        onChange={handleFileChange}
      />
    </div>
  );
};

export default FileUploader;
